import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { phoneNormalize } from 'shared/modules';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import DealerWebsiteLink from 'shared/components/DealerWebsiteLink/DealerWebsiteLink';
import DealerSocials from 'shared/components/DealerSocials/DealerSocials';
import withAdvertPhoneView from 'shared/hocs/withAdvertPhoneView';
import { withTranslate } from 'shared/hocs/withTranslate';
import withPixelRatio from 'shared/hocs/withPixelRatio';
import Link from 'shared/components/Link/Link';
import { FormattedMessage } from 'react-intl';
// eslint-disable-next-line css-modules/no-unused-class
import s from './AdvertSeller.css';

class SparepartsAdvertSeller extends React.Component {
  static propTypes = {
    advertID: PropTypes.number,
    authorName: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    location: PropTypes.string.isRequired,
    // authorEmail: PropTypes.string,
    avatar: PropTypes.string,
    link: PropTypes.string,
    agency: PropTypes.shape(),
    extraText: PropTypes.string,
    requestShowPhones: PropTypes.func.isRequired,
    phones: PropTypes.arrayOf(PropTypes.string),
    // messengers: PropTypes.arrayOf(PropTypes.shape()),
    sold: PropTypes.bool,
    active: PropTypes.number,
    setRatioImage: PropTypes.func.isRequired,
    isApprovePub: PropTypes.bool,
    //
    t: PropTypes.func.isRequired,
  };
  static defaultProps = {
    authorName: '',
    advertID: null,
    agency: null,
    avatar: null,
    link: null,
    extraText: null,
    phones: null,
    messengers: null,
    sold: false,
    active: 1,
    isApprovePub: false,
  };

  handleShowPhoneClick = () => {
    const { advertID, requestShowPhones } = this.props;
    if (advertID) {
      requestShowPhones(advertID);
    }
  };

  render() {
    const {
      authorName,
      location,
      avatar,
      link,
      extraText,
      phones,
      agency,
      sold,
      setRatioImage,
      active,
      isApprovePub,
      t,
    } = this.props;
    const website = agency && agency.website ? agency.website : null;
    const avatarImg = avatar && setRatioImage(avatar.replace('http:', 'https:'), 40);
    const isDeactivated = (active === -2 || !active || sold) && !isApprovePub;
    const messengers =
      agency && agency.messengers && !!agency.messengers.length && agency.messengers;

    return (
      <div className={s.root}>
        <div className={s.rowContainer}>
          {authorName &&
            <div className={s.row}>
              <div className={s.col}>
                <FormattedMessage id="Продавец" />
              </div>
              <Link to={link || null} className={link ? s.authorLink : s.colAuto}>
                {avatar && <img className={s.avatar} alt={''} src={avatarImg} />}
                {authorName}
                {extraText &&
                  <span className={s.authorExtraText}>
                    {extraText}
                  </span>}
              </Link>
            </div>}
          <div className={s.row}>
            <div className={s.col}>
              <FormattedMessage id="Адрес" />
            </div>
            <div className={s.colAuto}>
              {location}
            </div>
          </div>
        </div>
        <div className={s.flexColumnBlock}>
          {website &&
            <div className={s.write}>
              <DealerWebsiteLink dealer={agency} ClassName={s.writeBtn} />
            </div>}

          {!isDeactivated &&
            <div className={s.contactParts}>
              <div className={cx(s.contactBtn)} onClick={this.handleShowPhoneClick}>
                {phones &&
                  !phones.length &&
                  <div>
                    <FormattedMessage id="Нет телефонов" />
                  </div>}
                {phones &&
                  phones.length > 0 &&
                  phones.map(phone =>
                    <div key={phone} className={cx(s.phone)}>
                      <a href={`tel:${phoneNormalize(phone)}`}>
                        {phoneNormalize(phone)}
                      </a>
                    </div>,
                  )}
                {!phones &&
                  <div>
                    <div data-lens-event="showPhoneClick">{t('Показать телефон')}</div>
                    +••• •• ••• •• ••
                  </div>}
              </div>
            </div>}

          {messengers &&
            <div className={s.messengersBlock}>
              <DealerSocials messengers={messengers} />
            </div>}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(
  withAdvertPhoneView(withPixelRatio(withTranslate(SparepartsAdvertSeller))),
);



// WEBPACK FOOTER //
// ./src/desktop/components/AdvertSeller/SparepartsAdvertSeller.js